// Style for error layout
const Style = () => ({
  wrapper: {
    display: 'flex',
    minHeight: '100vh',
  },
});

export default Style;
